module.exports = __webpack_public_path__ + "img/green_011.4fef9f88.png";